module.exports = __webpack_public_path__ + "static/media/SAM_1291.67a924be.JPG";